@import '../utils/global.module.less';

.container {
    padding-left: var(--main-container-side-padding);
    padding-right: var(--main-container-side-padding);
    background-color: #fcfcfd !important;
    padding-top: 30px;
}

.tabsShadow {
    width: 100%;
    height: 35px;
    left: 0;
    top: 150px;
    //F0F0F1
    background: linear-gradient(
        180deg,
        rgba(240, 240, 240, 1) 0%,
        #fcfcfdff 60%,
        #fcfcfd00 100%
    );
    position: absolute;
    transform: translateY(45px);
    z-index: 10000;
    pointer-events: none;
}

.gptTabLabel {
    position: relative;
    top: -8px;
}
.gptTabLabel:hover .gptIcon {
    animation: scaleInOut 0.8s ease 1;
}
.gptIcon {
    position: absolute;
    display: inline-block;
    margin-left: 10px;
    width: 30px;
    height: 30px;
    top: 4px;
}
